import { GraphCard, useTranslation } from '@fareye/common'
import { Flex, Label, Span, InfoIcon } from '@fareye/ui'
import {
  FaSortDown,
  FaSortUp,
  IoIosAirplane,
  MdLocalShipping,
  MdDirectionsBoat,
  MdTrain,
  isEmpty
} from '@fareye/utils'

import React from 'react'
import { labelColor } from '../../../config/colors'
import { inTransitConstant } from '../../../config/constants'

const MultiModalTransporterCard = ({
  match,
  transporterData,
  label,
  location
}: any) => {
  const [toggle, setToggle] = React.useState(false)
  const SortIconStyle = {
    margin: 0,
    fontSize: '15px'
  }
  const { t } = useTranslation()

  const heading = (
    <Flex justifyContentSpaceBetween>
      <Flex justifyContentFlexStart>
        {t(label) || t(inTransitConstant.transporterPerformance)}
        <InfoIcon
          style={{ marginLeft: 5 }}
          title={t('Transporter Wise Top/Bottom Performers')}
        />
      </Flex>
      <Flex
        column
        style={{ margin: '0 5px -16px' }}
        onClick={() => setToggle(!toggle)}
      >
        <FaSortDown
          style={{
            ...SortIconStyle,
            marginBottom: '-9px',
            color: toggle ? '#666' : '#999'
          }}
        />
        <FaSortUp
          style={{
            ...SortIconStyle,
            marginTop: '-7px',
            color: toggle ? '#999' : '#666'
          }}
        />
      </Flex>
    </Flex>
  )
  return (
    <GraphCard graphId="" heading={heading}>
      {!isEmpty(transporterData) ? (
        <Flex
          column
          style={{ color: labelColor.normalText, flex: 1, width: '100%' }}
        >
          <Flex
            justifyContentSpaceBetween
            style={{ fontSize: '10px', padding: '3px 0' }}
          >
            <Span>{t('Name')}</Span>
            <Span>{t('Delivery Score')}</Span>
          </Flex>
          {transporterData &&
            transporterData
              .sort((a: any, b: any) => {
                const diff = b.percentageValue - a.percentageValue
                return toggle ? diff : -1 * diff
              })
              .filter((_: any, i: number) => i < 5)
              .map((item: any, index: number) => {
                const { transportMode } = item
                let TptMode: any = undefined
                if (transportMode[0] === 'air') {
                  TptMode = IoIosAirplane
                } else if (transportMode[0] === 'ocean') {
                  TptMode = MdDirectionsBoat
                } else if (transportMode[0] === 'road') {
                  TptMode = MdLocalShipping
                } else if (transportMode[0] === 'rail') {
                  TptMode = MdTrain
                } else {
                  TptMode = MdLocalShipping
                }
                return (
                  <Flex
                    justifyContentSpaceBetween
                    key={index}
                    style={{
                      marginTop: '10px',
                      color: item.percentageValue < 50 ? '#C81C1C' : 'inherit'
                    }}
                  >
                    <Flex justifyContentSpaceBetween>
                      <TptMode size={18} />
                      <Label
                        variant="h6"
                        style={{ fontWeight: 700, marginLeft: '8px' }}
                      >
                        {item.transporterName}
                      </Label>
                    </Flex>
                    <Label variant="h6" style={{ fontWeight: 700 }}>
                      {item.percentageValue}%
                    </Label>
                  </Flex>
                )
              })}
        </Flex>
      ) : (
        <Span>{t('No Data Found')}</Span>
      )}
    </GraphCard>
  )
}

export default MultiModalTransporterCard
